/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-2",
    "aws_cloud_logic_custom": [
        {
            "name": "chattoken",
            "endpoint": "https://asvrb1a2lc.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        },
        {
            "name": "customers",
            "endpoint": "https://quislqxuwb.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        },
        {
            "name": "paymentsheet",
            "endpoint": "https://ej621v7hn8.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        },
        {
            "name": "sites",
            "endpoint": "https://f2oxt4ancc.execute-api.eu-west-2.amazonaws.com/dev",
            "region": "eu-west-2"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-west-2:872e0c9b-5a4f-4c35-b57c-baf465d10af9",
    "aws_cognito_region": "eu-west-2",
    "aws_user_pools_id": "eu-west-2_f8vIfZqmf",
    "aws_user_pools_web_client_id": "6fhucuqnuqo7qhgvr0h7fenaug",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "imagesdev-dev",
    "aws_user_files_s3_bucket_region": "eu-west-2"
};


export default awsmobile;
